import type { Section } from '@common/formEngine/formEngine.types';
import type { DeepPickPath } from '@common/utils/deepPickUtils';
import type { NullablePrimitives } from '@common/utils/utilityTypes';

export type EchographyAdditionalQuestionResponseData = NullablePrimitives<{
    bericht: string;
}>;

export type EchographyAdditionalQuestionResponseKey = DeepPickPath<EchographyAdditionalQuestionResponseData>;

export const echographyAdditionalQuestionResponseSections: Section<EchographyAdditionalQuestionResponseData>[] = [
    {
        fields: [
            {
                isRequired: true,
                key: 'bericht',
                label: 'Bericht',
                type: 'textInput',
            },
        ],
    },
];
